/* eslint-disable ember/classic-decorator-no-classic-methods */
import { action } from '@ember/object';
import Controller from '@ember/controller';
import BulkImportStatus from 'linced-app/enums/bulk-import-status';

export default class IndexController extends Controller {
  BulkImportStatus = BulkImportStatus;

  @action
  nextPage() {
    this.incrementProperty('offset', 20);
  }

  @action
  prevPage() {
    this.decrementProperty('offset', 20);
  }
}
